/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, Image, Segment } from 'semantic-ui-react';
import LogoRegioneImage from './logo-comune-negativo.jpeg';
import LogoFice from './Logo-Fice.png';
import LogoMibact from './Logo-Mibact.gif';
import LogoECMedia from './ECMediaLogo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = () => (
  <div id="footer">
    <Container>
      <Segment basic className="discreet">
        <div className="flex justify-center flex-wrap align-center logo">
          <Image
            size="small"
            src={LogoRegioneImage}
            className="mx-2"
            width="175"
            height="70"
          />
          <Image
            size="small"
            src={LogoMibact}
            className="mx-2"
            width="175"
            height="88"
          />
          <Image
            size="small"
            src={LogoECMedia}
            className="mx-2"
            width="175"
            height="124"
          />
          <Image
            size="small"
            src={LogoFice}
            className="mx-2"
            width="175"
            height="96"
          />
        </div>
      </Segment>
      <div className="footer-container">
        <div className="footer-column">
          <h3 className="title">Seguici su</h3>
          <div className="social-container">
            <a
              href="https://www.facebook.com/cinemarosebud"
              title="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={['fab', 'facebook-f']} className="icon" />
            </a>
            <a
              href="https://www.instagram.com/cinemarosebud/"
              title="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={['fab', 'instagram']} className="icon" />
            </a>
            <a
              href="https://cinema-rosebud.newsletter.comune.re.it/user/register/"
              title="Iscriviti alla Newsletter"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon="envelope" className="icon" />
            </a>
          </div>
        </div>
        <div className="footer-column">
          <h3 className="title">Contatti</h3>
          <div>
            <p>via Medaglie d’Oro della Resistenza, 6</p>
            <p>42122 Reggio nell'Emilia</p>
            <p>
              <a href="tel:+390522456787">Tel. 0522.456787</a>
            </p>
          </div>
        </div>
        <div className="footer-column">
          <h3 className="title">Informazioni</h3>
          <div>
            <p>Ufficio cinema</p>
            <p>Piazza Casotti 1/c</p>
            <p>42121 Reggio nell'Emilia</p>
            <p>
              <a href="tel:+390522456632">Tel. 0522.456632</a>
            </p>
            <p>
              <a href="tel:+390522456805">Tel. 0522.456805</a>
            </p>
            <p>
              <a href="mailto:ufficiocinema@comune.re.it">
                ufficiocinema@comune.re.it
              </a>
            </p>
            <p>
              <a href="https://form.agid.gov.it/c_h223/cinema_rosebud/dichiarazione" target="_blank"  rel="noopener noreferrer">
                Dichiarazione di Accessibilità
              </a>
            </p>
          </div>
        </div>
      </div>
    </Container>
  </div>
);

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default Footer;
